import { useContext } from 'react';
import { ThemeContext } from '../../context/ThemeContext';

/**
* Renders a shimmering placeholder card for displaying language statistics while data loads.
* @example
* LanguageStatsSkeleton()
* <div className="rounded-lg p-6">...skeleton content...</div>
* @returns {JSX.Element} A skeleton layout consisting of animated placeholder rows for language stats.
**/
const LanguageStatsSkeleton = () => {
  const { theme } = useContext(ThemeContext);

  return (
    <div 
      className="rounded-lg p-6"
      style={{ 
        backgroundColor: theme.background.card,
        boxShadow: theme.shadow.md
      }}
    >
      {/* Header */}
      <div 
        className="h-6 rounded w-32 mb-4 animate-pulse"
        style={{ backgroundColor: theme.background.secondary }}
      />

      {/* Language items */}
      <div className="space-y-3">
        {[1, 2, 3, 4].map(i => (
          <div key={i} className="space-y-2">
            <div className="flex justify-between items-center">
              <div 
                className="h-4 rounded w-24 animate-pulse"
                style={{ backgroundColor: theme.background.secondary }}
              />
              <div 
                className="h-4 rounded w-16 animate-pulse"
                style={{ backgroundColor: theme.background.secondary }}
              />
            </div>
            <div 
              className="h-2 rounded w-full animate-pulse"
              style={{ backgroundColor: theme.background.secondary }}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default LanguageStatsSkeleton;
